import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import React from 'react';
import { OpenModalHookType } from '@hooks/useOpenModal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

interface ModalAddOrderNoteProps {
    modalAddOrderNote: OpenModalHookType;
    onAddOrderNote: (note: string) => void;
}

const addNoteSchema = Yup.object({
    note: Yup.string().required('Nota requerida')
});
export const ModalAddOrderNote: React.FunctionComponent<ModalAddOrderNoteProps> = (props: any) => {
    const { modalAddOrderNote, onAddOrderNote } = props;

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm<{ note: string }>({
        resolver: yupResolver(addNoteSchema)
    });

    const handleClose = () => {
        modalAddOrderNote.toggle();
    };

    const onDone: SubmitHandler<{ note: string }> = async (values) => {
        handleClose();
        reset();
        onAddOrderNote(values.note);
    };

    return (
        <Dialog
            PaperProps={{
                style: { borderRadius: 15, padding: 4 }
            }}
            open={modalAddOrderNote.modalOpen}
            onClose={handleClose}
            aria-labelledby="modal-product-info-title"
            aria-describedby="modal-product-info-description"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="modal-product-info-title">
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack>
                        <Typography variant="h6" fontWeight={600}>
                            Agregar una nota al pedido
                        </Typography>
                        <Typography variant="subtitle2">
                            Esta nota aparecerá en los detalles del pedido y en el tablero de cocina
                        </Typography>
                    </Stack>
                    <IconButton color="secondary" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <form id="add-note-form" onSubmit={handleSubmit(onDone)}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} mt={1}>
                            <Controller
                                name="note"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                    <TextField
                                        fullWidth
                                        required
                                        label="Nota"
                                        variant="outlined"
                                        value={value}
                                        onChange={onChange}
                                        error={!!errors.note}
                                        helperText={errors.note && errors.note.message}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions>
                <Button fullWidth color="primary" variant="contained" type="submit" form="add-note-form">
                    Agregar nota
                </Button>
            </DialogActions>
        </Dialog>
    );
};
